<!--service section start-->
<section class="agency format service-bg background" id="features">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="center-text">
                    <div class="format-container">
                        <h6 class="borders-before text-uppercase">
                            <span class="">{{'SERVICES.header.1' | translate}}</span>
                        </h6>
                        <div class="format-head-text">
                            <h1 class="about-font-header">{{'SERVICES.header.2' | translate}} <span class="block-span">
                                {{'SERVICES.header.3' | translate}}</span></h1>
                        </div>
                        <div class="format-sub-text">
                            <p class="about-para">
                                {{'SERVICES.description' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-sm-3 center-content m-t-150">
                        <ul class="icon-collection"
                            [@fadeInRight]="{ value: fadeInRight, params: { timing: 2, delay: 1.5 } }">
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/visualization'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/data-visualization.svg"
                                        alt="Data visualization development" class="filter-svg-to-primary-color" loading="lazy" width="63" height="63">
                                    <h6>{{'SERVICES.items.1' | translate}}</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3 center-content">
                        <ul class="icon-collection"
                            [@fadeInRight]="{ value: fadeInRight, params: { timing: 2, delay: 1.5 } }">
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/calculator'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/calculator.png"
                                        alt="Smart calculator development" loading="lazy">
                                    <h6>{{'SERVICES.items.2' | translate}}</h6>
                                </a>
                            </li>
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/optimization'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/process.png"
                                        alt="Business processes optimization" loading="lazy">
                                    <h6>{{'SERVICES.items.3' | translate}}</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3 center-content m-t-80">
                        <ul class="icon-collection"
                            [@fadeInRight]="{ value: fadeInRight, params: { timing: 3, delay: 1.5 } }">
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/datascience'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/analysis.png" alt="Data Science development"
                                        loading="lazy">
                                    <h6>{{'SERVICES.items.4' | translate}}</h6>
                                </a>
                            </li>
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/enterprise'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/software-development.png"
                                        alt="Enterprise software development" loading="lazy">
                                    <h6>{{'SERVICES.items.5' | translate}}</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3 center-content m-t-160">
                        <ul class="icon-collection"
                            [@fadeInRight]="{ value: fadeInRight, params: { timing: 4, delay: 1.5 } }">
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/maintenance'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/platform.png"
                                        alt="Maintenance software development" loading="lazy">
                                    <h6>{{'SERVICES.items.6' | translate}}</h6>
                                </a>
                            </li>
                            <li class="about-icon">
                                <a [routerLink]="'/'+ language +'/development'" class="center-content service-sound"><img
                                        src="assets/images/agency/service/technology.png"
                                        alt="Business processes software development" loading="lazy">
                                    <h6>{{'SERVICES.items.7' | translate}}</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--service section end-->